export const UPDATE_CURRENT_STEP_INDEX = "UPDATE_CURRENT_STEP_INDEX";
export const UPDATE_REGISTER_EMAIL = "UPDATE_REGISTER_EMAIL";
export const UPDATE_REGISTER_PHONE = "UPDATE_REGISTER_PHONE";
export const UPDATE_FIRST_NAME = "UPDATE_FIRST_NAME";
export const CHANGE_CURRENT_STEP_4_INDIVIDUAL_STATUS =
  "CHANGE_CURRENT_STEP_4_INDIVIDUAL_STATUS";
